
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import CustomersApi from "@/services/customers-api";
import UsersApi from "@/services/users-api";
import ReportingCustomerComponent from "../reporting/reporting-customer-component.vue";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout,ReportingCustomerComponent},

    mounted(){

      this.getCustomers()

  },

  computed: {

  },

  data() {
    return {
    

      customersList:[],
      selectedCustomer:null,
      simulatedCustomerUpdated: false,
      reportingCustomerKey: 0


    };
  },

  watch:{
    selectedCustomer:function(){
      if(this.selectedCustomer != null){
        this.setSimulatedCustomer()
      }else{
        this.selectedCustomer = this.customersList[0]
      }

    }
  },


  methods: {
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          this.selectedCustomer = this.customersList[0]
        }
      )
    },

    setSimulatedCustomer(){
      UsersApi.setSimulatedCustomer(this.selectedCustomer.id).then(
          response => {
          this.simulatedCustomerUpdated=response;
          this.reportingCustomerKey ++
          }
      )
    },

  }
};
</script>

<template>
  <Layout>

    <div class="p-sm-4">


      <div class="home-page-80-width mb-5 ">
              <div class="card h-100" style="border:1px solid #ddd;">
                <div class="card-body card bg-light p-3">
                  <h4 class="text-dark text-uppercase font-weight-bold">{{ $t('reporting.customer.cardTitle') }}</h4>

                  <h6 class="text-secondary font-weight-bold">{{ $t('reporting.customer.campaign') }}</h6>


                  <b-form-group label-for="" class="mt-3">
                      <v-select class="col-xl-4 col-md-5 col-12" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="name" v-model="selectedCustomer">
                      <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                      </v-select>
                  </b-form-group>
                  
                </div>
              </div>
          </div>

      <ReportingCustomerComponent v-if="simulatedCustomerUpdated" 
          :key="this.reportingCustomerKey"> 
      </ReportingCustomerComponent>


    </div>

  </Layout>
</template>
















